<template>
    <div class="container">
        <h2 class="title is-5">v-forのサンプルコード</h2>
        <p>v-for(forループ)のサンプルコードです</p>
        <b-tag type="is-info">Vue.js</b-tag>
        <hr/>
        <h3 class="title is-5">サンプル</h3>
        <ForComponent />
        <hr/>
        <p class="title is-5">コード</p>
        <p style="margin-bottom:10px;"><b-button @click="twitterShare" class="is-info" size="is-small"><i class="fab fa-twitter"></i>シェアする</b-button></p>
        <div class="iframely-embed"><div class="iframely-responsive" style="padding-bottom: 56.2493%;"><a href="https://gist.github.com/katonobo/e76203ffe99e188f68c6fa8c4ac1a65b" data-iframely-url="//cdn.iframe.ly/KWLyiIv"></a></div></div>
        <hr>
        <p class="title is-5">解説</p>
        <p>Vueのfor文、v-forのサンプルコードです。</p>
    </div>
</template>

<script>
import ForComponent from  '@/components/ForComponent.vue'
export default {
    components:{
        ForComponent
    },
    mounted(){
        const title = "v-forのサンプルコード｜あめねこサンプルコード集"
        const description = "Vue.jsで作るv-for(forループ)のサンプルコードです"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    
        window.iframely.load();
    },
    methods:{
        twitterShare(){
            var shareURL = 'https://twitter.com/intent/tweet?text=' + "v-forのサンプルコードです" + "%20%23あめねこサンプルコード集" + '&url=' + "https://code.ameneko.com/for";  
            location.href = shareURL
        }
    }
}
</script>

<style scoped>
.container{
    max-width: 1000px;
    margin:auto;
    margin-bottom: 40px;
    padding: 10px;
}

</style>